module.exports = __webpack_public_path__ + "img/a011_5.6ed15c6a.png";